export default __webpack_public_path__ + "static/media/mypic.a4f7227a.jpeg";